<template>
    <ul class="side_list clearfix">
      <li
        v-for="(item,index) in tabs"

        @click="tab(index)"
        v-show="!(role==2 && (index==3||index==4))"
        ><router-link :to="{name:'list',params: { index: index }}">{{item}}</router-link></li>
    </ul>
</template>
<script>
//  :to="{ params: { index: index }}"
  import Vue from 'vue'
  export default{
    name:'sideBar',
    data () {
      return {
        tabs:['在职人员','退休人员','离职人员','养老金参数配置','权限设置','个人信息'],
        num:this.$route.params.index || 0,
        role:Number
      }
    },
    methods: {
      tab(index){
        this.num = index;
        this.setLisClass();
      },
      setLisClass(){
        var lis = document.getElementsByClassName('side_list')[0].children;
        for(var i=0;i<lis.length;i++){
          lis[i].className='icon'+i;
          if(i==this.num){
            lis[i].className = "active icon-hover"+i;
          }
        }
      }
    },
    mounted:function(){
      this.setLisClass();
      this.role=localStorage.getItem('role');
//      if(role==2){
//        this.tabs=['在职人员','退休人员','离职人员','个人信息']
//      }

    }
//    watch:{
//      'num':function(){
//        this.setLisClass();
//      }
//    }
  }
</script>
<style lang="less">
  .side_list{
    float: left;
    width:240px;
    position:fixed;
    top:70px;
    bottom:0;
    border-right:1px solid #b9bac2;
    background:#fff;
    z-index:100;
    li:nth-child(1){
      margin-top: 30px;
    }
    li{
      width:170px;
      text-align: left;
      height: 45px;
      color: #323232;
      background: rgba(216,216,216,.1);
      margin-bottom: 25px;
      padding-left: 70px;
      cursor: pointer;
      a{
        display: block;
        width:100%;
        height:100%;
        line-height: 45px;
        font-size: 18px;
      }
    }
    li.active{
      border-left: 6px solid #00A5FA;
      padding-left: 64px;
      width: 170px;
      a{
        color: #00A5FA;
      }

    }
    .icon0{
      background: url("../../static/images/worker.png") 25px center no-repeat;
      background-size: 30px ;
    }
    .icon-hover0{
      background: url("../../static/images/worker-hover.png") 19px center no-repeat;
      background-size: 30px ;
    }
    .icon1{
      background: url("../../static/images/retire.png") 25px center no-repeat;
      background-size: 30px ;
    }
    .icon-hover1{
      background: url("../../static/images/retire-hover.png") 19px center no-repeat;
      background-size: 30px;
    }
    .icon2{
      background: url("../../static/images/leaver.png") 25px center no-repeat;
      background-size: 30px ;
    }
    .icon-hover2{
      background: url("../../static/images/leaver-hover.png") 19px center no-repeat;
      background-size: 30px;
    }
    .icon3{
      background: url("../../static/images/pensionParams.png") 25px center no-repeat;
      background-size: 30px ;
    }
    .icon-hover3{
      background: url("../../static/images/pensionParams-hover.png") 19px center no-repeat;
      background-size: 30px;
    }
    .icon4{
      background: url("../../static/images/adminSet.png") 25px center no-repeat;
      background-size: 30px ;
    }
    .icon-hover4{
      background: url("../../static/images/adminSet-hover.png") 19px center no-repeat;
      background-size: 30px;
    }
    .icon5{
      background: url("../../static/images/personInfo.png") 25px center no-repeat;
      background-size: 30px ;
    }
    .icon-hover5{
      background: url("../../static/images/personInfo-hover.png") 19px center no-repeat;
      background-size: 30px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/siderBar.vue